import { useEffect } from "react";
import { Grid } from "@mantine/core";

import { QuestionnaireFormProvider, QuestionsEditorForm, useQuestionnaireForm } from "../QuestionnaireEditor";
import { useCreateCampaignInquiryFormContext } from "./formContext";
export interface CreateCampaignInquiryQuestionnaireFormProps {
    questionsLimit: number;
}

export const CreateCampaignInquiryQuestionnaireForm = ({
    questionsLimit,
}: CreateCampaignInquiryQuestionnaireFormProps) => {
    const createCampaignInquiryForm = useCreateCampaignInquiryFormContext();

    const questionnaireForm = useQuestionnaireForm({
        initialValues: createCampaignInquiryForm.values?.questionnaire,
    });

    useEffect(() => {
        createCampaignInquiryForm.setFieldValue("questionnaire", questionnaireForm.values);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(questionnaireForm.values)]);

    return (
        <QuestionnaireFormProvider form={questionnaireForm}>
            <Grid>
                <Grid.Col xs={12} sm={12} md={12}>
                    <QuestionsEditorForm customQuestionKeyPrefix=":CUSTOM" questionsLimit={questionsLimit} />
                    {/* <Paper p="lg" shadow="sm" radius="sm" withBorder>
                        <CriteriaEditorForm/>
                    </Paper> */}
                </Grid.Col>
            </Grid>
        </QuestionnaireFormProvider>
    );
};
